import { ItemOptionsQuantities } from "@/types";
import { atom } from "jotai";

const itemOptionsQuantitiesAtom = atom<Record<string, ItemOptionsQuantities>>({})

export default itemOptionsQuantitiesAtom
